<template>
  <div v-if="showDeliveryGuranteeFlow">
    <div
      class="deliveryTimeModule"
      v-if="delTimeFromStore && shouldVisible"
      :falsePropVarant="currentStore"
    >
      <div v-if="delTimeFromStore === '20'">
        <VueLottiePlayer
          name="offerIconAnim"
          width="100%"
          height="100%"
          loop
          :path="
            staticImgBaseUrl +
            '/images/animation/ngh-delivery-time-20.json'
          "
        />
      </div>
      <div v-else-if="delTimeFromStore === '30'">
        <div class="location-20min-banner hauto" v-if="!startAnimation">
          <div class="align-items-center flex-row justify-content-between">
            <div class="upperTriangle"></div>
            <div
              class="italic location-time-parent flex-row align-items-center"
            >
              <div class="flex-row">
                <img
                  src="../../../default/images/global/del-gurantee.svg"
                  class=""
                />
              </div>
              <div>
                <span class="location-20min-time mr5">30 minutes</span>
                <span class="location-delivery-guarantee">DELIVERY</span>
              </div>
            </div>
            <div class="lowerTriangle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import setEvents from "../helpers/events";
import utility from "../helpers/utility.js";
import amplitude from "amplitude-js";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl } from "../config/apiEndpoints";

export default {
  name: "DeliveryTime",
  props: ["moduleProps"],
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  data() {
    return {
      shouldVisible: false,
      modulePropsData: {},
      staticImgBaseUrl: staticImgBaseUrl
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}, itemArr = []) {
      let eventType = isClicked ? "Click" : "nghDeliveryTimeImpression";

      const eventObj = utility.amplitudeEventObj(
        eventType,
        "30 20 banner",
        "4",
        eObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
  },

  computed: {
    delTimeFromStore() {
      let { timeServiceGuarantee } = this.$store.state.Location.storeDetails;
      if (
        this.currentOrderType == "D" &&
        timeServiceGuarantee !== undefined &&
        timeServiceGuarantee !== null
      ) {
        if (
          timeServiceGuarantee?.type == "20" ||
          timeServiceGuarantee?.type == "30"
        ) {
          this.eventFunction(false, {
            category: timeServiceGuarantee?.type,
          });
        }
        amplitude.setUserProperties({
          nghDeliveryTime: timeServiceGuarantee?.type
            ? timeServiceGuarantee?.type
            : "",
        });

        return String(timeServiceGuarantee?.type);
      } else {
        return false;
      }
    },
    showDeliveryGuranteeFlow() {
      return window?._siteProps_?.props?.enableDeliveryGuranteeFlow === "true";
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    currentStore() {
      let currentStore = LocalStorageFunc.storeId();
      let storeForDeliveryTimeBannnerIs =
        localStorage.getItem("storeForDeliveryTimeBannner") || null;
      if (
        storeForDeliveryTimeBannnerIs &&
        currentStore != storeForDeliveryTimeBannnerIs
      ) {
        localStorage.setItem("storeForDeliveryTimeBannner", "");
      }

      if (this.delTimeFromStore === "20" || this.delTimeFromStore === "30") {
        let deliveryTimeBannerVisibilty = JSON.parse(
          localStorage.getItem("shouldDeliveryTimeBannnerVisible")
        );
        let preStore = localStorage.getItem("previousStoreId");
        let storeForDeliveryTimeBannnerIs = localStorage.getItem(
          "storeForDeliveryTimeBannner"
        );

        if (
          deliveryTimeBannerVisibilty === undefined ||
          deliveryTimeBannerVisibilty === null
        ) {
          localStorage.setItem("shouldDeliveryTimeBannnerVisible", true);
          deliveryTimeBannerVisibilty = true;
        } else if (
          preStore &&
          currentStore != preStore &&
          deliveryTimeBannerVisibilty === false &&
          storeForDeliveryTimeBannnerIs != currentStore
        ) {
          localStorage.setItem("shouldDeliveryTimeBannnerVisible", true); //new banner store
        }
        return currentStore;
      } else {
        return false;
      }
    },
  },
  watch: {
    currentStore: {
      handler(newVal, oldVal) {
        if (newVal) {
          let preStore = localStorage.getItem("previousStoreId");
          let deliveryTimeBannerVisibilty = JSON.parse(
            localStorage.getItem("shouldDeliveryTimeBannnerVisible")
          );
          if (preStore != newVal && deliveryTimeBannerVisibilty) {
            this.shouldVisible = true;
          }
        }
      },
      immediate: true,
    },
    shouldVisible: {
      handler(newVal, oldVal) {
        if (newVal) {
          let temp = this;
          setTimeout(() => {
            temp.shouldVisible = false;
            localStorage.setItem("shouldDeliveryTimeBannnerVisible", false);
            localStorage.setItem(
              "storeForDeliveryTimeBannner",
              LocalStorageFunc.storeId()
            );
          }, Number(temp.modulePropsData?.bannerTimeOut));
        }
      },
    },
  },
};
</script>

<style scoped></style>
